package ru.villawonka.app.common.extensions

fun String.priceFormat(): String = this
    .reversed()
    .chunked(3)
    .joinToString(" ")
    .reversed()